import { render, staticRenderFns } from "./DVRList.vue?vue&type=template&id=9f8bedbe&"
import script from "./DVRList.vue?vue&type=script&lang=js&"
export * from "./DVRList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports